/* eslint-disable no-unused-vars */
import axios from 'axios';

import CourseService from '../../../service/CourseService/CourseService'

const course = new CourseService()

const state = {
    course: {
        id: '',
        title: '',
        description: '',
        name:''
    }
};

const getters = {

};

const mutations = {
    set_name(state, course) {
        state.course = course;
      },
};

const actions = {

    onSaveCourse({
        commit
    }, payload) {
        console.log(payload);
        return new Promise((resolve, reject) => {
            course.postCourse(payload).then((res) => {
                const course_id = res.data.id;
                resolve(course_id);
                // console.log(res);
            })
        })
    },
    getCourseByName({ commit }) {
        return new Promise((resolve, reject) => {
            CourseService
            .getProfile()
            .then(resp => {
              console.log(resp);
              commit('set_name', resp.data.data.slug);
              resolve(resp.data.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};